import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chrome" }
const _hoisted_2 = { class: "header pp-4" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "actions" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "body pp-4" }
const _hoisted_7 = { class: "footer pp-4" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["aria-label"]

import { useI18n } from '@shell/composables/useI18n';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { Props } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'Chrome',
  props: {
    ariaTarget: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const store = useStore();
const i18n = useI18n(store);

const ariaLabel = computed(() => i18n.t('component.drawer.chrome.ariaLabel.close', { target: props.ariaTarget }));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "header", {}, () => [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _cache[3] || (_cache[3] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn role-link",
            "aria-label": ariaLabel.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
          }, _cache[2] || (_cache[2] = [
            _createElementVNode("i", { class: "icon icon-close" }, null, -1)
          ]), 8, _hoisted_5)
        ])
      ])
    ]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "body")
    ]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "btn role-secondary",
            "aria-label": ariaLabel.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
          }, _toDisplayString(_unref(i18n).t('component.drawer.chrome.close')), 9, _hoisted_9),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _renderSlot(_ctx.$slots, "additional-actions")
        ])
      ])
    ])
  ]))
}
}

})